import { minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, smallElevation } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

import { getIconPath } from 'src/utils/assetPaths';

const CLOSE = getIconPath('icons-24-close.svg');

const { spacing, typography } = themeVariables;

export const section = css`
  box-shadow: -4px 0 8px 0 rgba(0, 0, 0, 0.2);
  padding: 0;
  position: fixed;
  background: var(--neutral-white-base);
  top: 0;
  right: 0;
  height: 100%;
  min-width: 100%;
  display: flex;
  flex-direction: column;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      min-width: 0;
    `,
  )};
`;

export const header = css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  padding: var(${spacing.md});
`;

export const closeButton = css`
  width: 48px;
  height: 48px;
  padding: 0;
  display: block;
  border: none;
  background-color: transparent;
  background-image: url(${CLOSE});
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  ${smallElevation};
  border-radius: 50%;
`;

export const content = css`
  padding: 0 var(${spacing.md}) var(${spacing.xl});
  overflow-y: auto;
  flex-grow: 1;
  min-height: 0;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      padding: 0 var(${spacing.xl}) var(${spacing.xl});
    `,
  )}
`;

export const heading = css`
  font-size: var(${typography.heading.sizes.xs.fontSize});
  line-height: var(${typography.heading.sizes.xs.lineHeight});
  letter-spacing: var(${typography.heading.letterSpacing});
  margin: var(${spacing.md}) 0;
`;

export const footer = css`
  flex-shrink: 0;
  padding: var(${spacing.md});
  background: var(--neutral-white-base);
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.2);
`;
